<template>
  <div>
    <el-form ref="formQuery" label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="$t('collectionCenter.CustomerName')"
            prop="region"
            style="width: 100%"
          >
            <el-select
              v-model="queryForm.customerName"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              clearable
              filterable
              style="width: 100%"
              remote
              reserve-keyword
              :remote-method="getUserOption"
              @focus="getUserOption()"
              @change="selectCustomeId"
            >
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option
                v-for="(item, index) in customerList"
                :key="index"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--商家-->
          <el-form-item
            :label="$t('collectionCenter.merchant')"
            prop="merchantCode"
            style="width: 100%"
          >
            <el-select
              v-model="queryForm.merchantCode"
              :disabled="!queryForm.customerName"
              :placeholder="$t('placeOrder.pleaseChoose')"
              :remote-method="eventEnter"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @clear="eventEnter('')"
            >
              <el-option
                v-for="item in commercialList"
                :key="item.id"
                :label="item.merchantName"
                :value="item.merchantCode"
              >
                <span style="float: left">{{ item.merchantName || '--' }}</span>
                <span style="margin-left: 20px; margin-right: 5px">{{
                  item.merchantCode || '--'
                }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$t('collectionCenter.region')" prop="regionId">
            <el-select
              v-model="queryForm.regionId"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!--网点所属州、收件人州-->
        <el-col :span="5">
          <el-form-item :label="$t('GlobalSetObj.Estado')" prop="state">
            <el-select
              v-model="queryForm.state"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              style="width: 90%"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.shortName"
                :value="item.shortName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$t('uploadFile.requiredDeliveryTime')">
            <el-date-picker
              v-model="dateArr"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('operationCenter.endDate')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('operationCenter.startDate')"
              popper-class="dateTimeClass"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @blur="refreshDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="17">
          <div style="display: flex; justify-content: space-between; margin-top: 27px">
            <div>
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="searchTable(1)"
              >
                {{ $t('GlobalSetObj.search') }}
              </el-button>
              <el-button
                icon="el-icon-refresh-left" size="small" @click="searchTable(2)"
              >{{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                size="small" @click="exportsTable()"
              >{{ $t('operationCenter.exports') }}
              </el-button>
            </div>
            <div>
              <el-radio-group
                v-model="queryForm.dataType"
                size="small"
                @input="() => searchTable(1)"
              >
                <el-radio-button :label="1">{{ $t('collectionCenter.ballot') }}</el-radio-button>
                <el-radio-button
                  :label="2"
                >{{ $t('orderCenterCont.proportions') }}
                </el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="sheind-table2">
      <el-table
        :cell-class-name="tableCellClassName"
        :data="tableData"
        :row-class-name="tableRowClassName"
        :span-method="arraySpanMethod"
        border
        max-height="600"
      >
        <el-table-column
          v-for="(item, ind) in columnList"
          :key="ind"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row[item.prop] !== '' &&
                  scope.row[item.prop] !== null &&
                  scope.row[item.prop] !== undefined
                  ? scope.row[item.prop]
                  : '--'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in currentColumnList"
          :key="ind + item.prop"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div
              :class="
                queryForm.dataType === 1 &&
                  ![
                    '订单数Qtd. de Pedidos',
                    '已签收数Qtd. de pacotes entregues',
                    '签收率Taxa de Pacotes Entregues',
                    '准时签收量Qtd. de Entregas Pontuais',
                    '准时签收率Taxa de Entregas Pontuais'
                  ].includes(scope.row.Region)
                  ? 'table-active'
                  : ''
              "
              @click="getVoteDetails(scope.row, item.prop)"
            >
              {{
                scope.row[item.prop] !== '' &&
                  scope.row[item.prop] !== null &&
                  scope.row[item.prop] !== undefined
                  ? scope.row[item.prop]
                  : '--'
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    票数详情-->
    <el-drawer
      :title="$t('orderCenterCont.votesDetails')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="990px"
      @close="closeDrawer"
    >
      <detail
        :key="dialogVisible"
        ref="votesDetails"
        :customer-list="customerList"
        :query-data="queryData"
        :select-data="stateList"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  regionQueryList,
  reportSheinDeliveredDaily,
  reportSheinDeliveredDailyExport,
  selectState
} from '@/api/orderApi';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';

import { apiCustomerPageList01, getMerchantByCustomerId01, apiCustomerPage } from '@/api/customer';

export default {
  name: 'DailyDeliveryData',
  components: {
    detail: () => import('./detail.vue')
  },
  data() {
    return {
      regionList: [],
      customeId: '',
      commercialList: [], // 商户列表
      queryForm: {
        region: null,
        state: '',
        beginTime: '',
        endTime: '',
        dataType: 1, // 1：票数 2：比例
        customerName: null,
        merchantCode: null,
        regionId: null
      },
      dateArr: [this.getAWeek().startDate + ' 00:00:00', this.getAWeek().endDate + ' 23:59:59'],
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const min = minTime;
          // const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000;
          const newDate = ((d) => (d.setHours(0, 0, 0, 0), d.setDate(d.getDate() + 1), d.getTime()))(new Date());
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      columnList: [
        { label: '大区（Região）', prop: 'Region', width: 200, align: 'center' },
        { label: '州（Estado）', prop: 'State', width: 150, align: 'center' },
        { label: '城镇类型（Tipo de cidade）', prop: 'Cluster', width: 240, align: 'center' },
        // { label: '目标值（Alvo）', prop: 'Target', width: 180, align: 'center' },
        { label: '总计（Total）', prop: 'total', width: 150, align: 'center' }
      ],
      currentColumnList: [],
      tableData: [],
      stateOptionList: [],
      dialogVisible: false, // 票数明细弹窗
      // 虚拟下拉框列表组件的参数
      // selectData: {
      //   data: [], // 下拉框数据
      //   label: 'state', // 下拉框需要显示的名称
      //   value: 'twoCode', // 下拉框绑定的值
      //   isRight: true // 右侧是否显示
      // },
      queryData: {
        moduleType: '', // 票数明细弹窗模块类型
        expectedTime: '', // 理应送达时间
        region: '', // 区域
        cluster: '', // 集群
        customerName: null,
        merchantCode: null,
        regionId: null
      },
      customerList: [],
      stateList: []
    };
  },
  watch: {
    'queryForm.regionId'(newVal) {
      this.queryForm.state = '';
      // 当 regionId 发生变化时，重新设置 stateList
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateList = selectedRegion.states.map((shortName) => ({ shortName }));
        }
      } else {
        this.stateList = [];
        this.getState();
      }
    }
  },
  created() {
    this.getTableData(1);
    // this.getStateOption();
    this.getUserOption();
    this.getState();
    this.getRegion();
  },
  methods: {
    // 大区
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 选择客户
    selectCustomeId(val) {
      console.log(val, '选择客户');
      this.commercialList = [];
      this.queryForm.merchantCode = '';
      if (val) {
        this.customeId = val;
        getMerchantByCustomerId01(val, '').then((res) => {
          if (res.code === 200) {
            this.commercialList = res.data;
          }
        });
      }
    },
    // 触发回车事件使用节流
    eventEnter(query) {
      apiCustomerPageList01(this.customeId, query).then((res) => {
        if (res.code === 200) {
          this.commercialList = res.data;
        }
      });
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
    },
    // 获取网点所属州，收件人州
    getState(name = '') {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.records;
        }
      });
    },
    // 客户名称列表
    getUserOption(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 导出
    exportsTable() {
      if (this.dateArr && this.dateArr.length > 0) {
        this.queryForm.beginTime = this.dateArr[0];
        this.queryForm.endTime = this.dateArr[1];
      } else {
        this.queryForm.beginTime = '';
        this.queryForm.endTime = '';
        this.$message.warning(this.$t('trajectory.DatesCannotBeEmpty'));
        return;
      }
      let queryFormCustomerName = null;
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      if (this.queryForm.customerName) {
        queryFormCustomerName = this.customerList.find(
          (item) => item.id === this.queryForm.customerName
        );
        queryForm.customerName = queryFormCustomerName.username;
      }
      queryForm.agingType = 8;
      reportSheinDeliveredDailyExport(queryForm).then((res) => {
        goResourceTaskList();
      });
    },
    // 指定列设置样式
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0 &&
        (row.Region === '订单数Qtd. de Pedidos' ||
          row.Region === '已签收数Qtd. de pacotes entregues' ||
          row.Region === '签收率Taxa de Pacotes Entregues' ||
          row.Region === '准时签收量Qtd. de Entregas Pontuais' ||
          row.Region === '准时签收率Taxa de Entregas Pontuais')
      ) {
        return 'choose-cell';
      }
    },
    // 指定行设置背景色
    tableRowClassName({ row, rowIndex }) {
      if (
        row.Region === '订单数Qtd. de Pedidos' ||
        row.Region === '已签收数Qtd. de pacotes entregues' ||
        row.Region === '签收率Taxa de Pacotes Entregues' ||
        row.Region === '准时签收量Qtd. de Entregas Pontuais' ||
        row.Region === '准时签收率Taxa de Entregas Pontuais'
      ) {
        return 'choose-row';
      }
    },
    // 搜索
    searchTable(type) {
      if (type === 1) {
        this.getTableData(1);
      } else {
        this.queryForm = {
          region: null,
          state: '',
          beginTime: '',
          endTime: '',
          dataType: 1,
          customerName: null,
          merchantCode: null,
          regionId: null
        };
        this.dateArr = [
          this.getAWeek().startDate + ' 00:00:00',
          this.getAWeek().endDate + ' 23:59:59'
        ];
        this.getTableData();
      }
    },
    // 获取列表数据
    getTableData(val) {
      if (this.dateArr && this.dateArr.length > 0) {
        this.queryForm.beginTime = this.dateArr[0];
        this.queryForm.endTime = this.dateArr[1];
      } else {
        this.queryForm.beginTime = '';
        this.queryForm.endTime = '';
        this.$message.warning(this.$t('trajectory.DatesCannotBeEmpty'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      let queryFormCustomerName = null;
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      if (this.queryForm.customerName) {
        queryFormCustomerName = this.customerList.find(
          (item) => item.id === this.queryForm.customerName
        );
        queryForm.customerName = queryFormCustomerName.username;
      }
      queryForm.agingType = 8;
      console.log(queryForm, '===queryForm');
      reportSheinDeliveredDaily(queryForm)
        .then((res) => {
          if (res.code === 200) {
            this.tableData = [];
            this.currentColumnList = [];
            res.data.rows.map((item) => {
              const rowsObj = { label: item, prop: item, width: 120, align: 'center' };
              this.currentColumnList.push(rowsObj);
            });
            if (this.queryForm.dataType === 1) {
              const orders = res.data.data.orders.map((item) => {
                item.type = 'orders';
                return item;
              });
              const delivered = res.data.data.delivered.map((item) => {
                item.type = 'delivered';
                return item;
              });
              const onTime = res.data.data.onTime.map((item) => {
                item.type = 'onTime';
                return item;
              });
              this.tableData = [...orders, ...delivered, ...onTime];
            } else if (this.queryForm.dataType === 2) {
              this.tableData = [
                ...res.data.data.orders,
                ...res.data.data.percentDelivered,
                ...res.data.data.percentOnTime
              ];
            }
            if (val === 1) {
              loading.close();
            }
            console.log(this.tableData, 'this.tableData');
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    // 获取最近15天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(15, 'day').format('YYYY-MM-DD')
      };
    },
    // 日期选择器失去焦点
    refreshDate() {
      this.choiceDate0 = '';
    },
    /**
     * 合并单元格表格州相同的数据
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {{colspan: number, rowspan: number}}
     */
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 第一列中 region 相等的合并
      if (columnIndex === 0) {
        // 不合并 region 为 "~" 的情况
        if (row.Region === '~') {
          return [1, 1];
        }
        if (rowIndex > 0 && row.Region === this.tableData[rowIndex - 1].Region) {
          return [0, 0];
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].Region === row.Region) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }

      // 第二列中 region 和 state 都相等的合并
      if (columnIndex === 1) {
        // 不合并 state 为 "~" 的情况
        if (row.State === '~') {
          return [1, 1];
        }

        // 检查上一行是否与当前行 region 和 state 都相同
        if (
          rowIndex > 0 &&
          row.State === this.tableData[rowIndex - 1].State &&
          row.Region === this.tableData[rowIndex - 1].Region
        ) {
          return [0, 0];
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            // 必须同时满足 region 和 state 都相同
            if (this.tableData[i].State === row.State && this.tableData[i].Region === row.Region) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }

      return [1, 1];
    },
    /**
     * @description 获取票数详情
     * @param row
     */
    getVoteDetails(row, prop) {
      if (this.queryForm.dataType === 2) {
        return;
      }
      if (
        [
          '订单数Qtd. de Pedidos',
          '已签收数Qtd. de pacotes entregues',
          '签收率Taxa de Pacotes Entregues',
          '准时签收量Qtd. de Entregas Pontuais',
          '准时签收率Taxa de Entregas Pontuais'
        ].includes(row.Region)
      ) {
        return;
      }
      this.dialogVisible = true;
      // 查询票数详情列表参数
      this.queryData = {
        moduleType: row.type,
        expectedTime: prop,
        region: this.queryForm.region,
        cluster: row.Cluster,
        state: row.State,
        regionId: row.RegionId,
        customerName: this.queryForm.customerName,
        merchantCode: this.queryForm.merchantCode,
        agingType: 8
      };
      console.log(row, 'rowrowrow');
      this.$nextTick(() => {
        this.$refs.votesDetails.search();
      });
    },
    /**
     * @description 关闭抽屉
     */
    closeDrawer() {
      this.dialogVisible = false;
      this.$refs.votesDetails.resetForm();
    }
  }
};
</script>

<style>
.sheind-table2 .el-table {
  color: #333;
  font-size: 16px;
}

.sheind-table2 .el-table thead {
  color: #fff;
}

.sheind-table2 .el-table th.el-table__cell {
  background-color: #000;
}

.sheind-table2 .choose-row {
  background-color: #1caa22;
}

.sheind-table2 .choose-cell {
  font-weight: bold;
}

.sheind-table2 .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: transparent !important;
}

.dateTimeClass.el-picker-panel .el-picker-panel__footer .el-button--text {
  display: none;
}

.table-active {
  color: #409eff;
  cursor: pointer;
}

.stateType .el-input__inner {
  border: 0;
  padding: 0;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
}
</style>
